import React from "react";
import Chart from "react-apexcharts";
import { useOutletContext } from 'react-router-dom';
import { CHART_TITLE_STYLE, buildPieSeries, pieSliceLabel, pieLegendWithValue } from "../HelperFunction/helperFunction";

function PieCharts({ fulldataset, isValue, type, range }) {
  const { theme } = useOutletContext();
  const isDark = theme !== 'light';
  const rows = fulldataset?.plot2 || [];
  const rowFor = (types, index) =>
    rows.find((item) => types.includes(item?.type)) || rows[index];
  const readPercent = (row, field) => {
    const n = Number(row?.[field]);
    return Number.isFinite(n) ? n : 0;
  };
  const core = rowFor(["Core"], 0);
  const incremental = rowFor(["Incremental", "Increment"], 1);
  const media = rowFor(["Media"], 2);
  const plotdata = isValue
    ? [
      { name: "Core", data: readPercent(core, "total_core_sales_percent") },
      { name: "Incremental", data: readPercent(incremental, "total_incremental_sales_percent") },
      { name: "Media", data: readPercent(media, "total_media_sales_percent") },
    ]
    : [
      { name: "Core", data: readPercent(core, "total_core_percent") },
      { name: "Incremental", data: readPercent(incremental, "total_incremental_percent") },
      { name: "Media", data: readPercent(media, "total_media_percent") },
    ];

  const { percents, display } = buildPieSeries(plotdata.map((item) => item.data));
  const realPct = (opts) => percents[opts?.seriesIndex] ?? 0;

  const options = {
    labels: ["Core", "Incremental", "Media"],
    title: {
      text: `Contribution Percentage (${type})`,
      align: "left",
      margin: 10,
      style: CHART_TITLE_STYLE,
    },
    chart: {
      id: `contribution-pie-${String(type).replace(/[^a-zA-Z0-9]+/g, "-")}`,
      type: "donut",
      toolbar: { show: true },
      background: "transparent",
    },
    colors: ["#17A2B8", "#FF8C00", "#0D7C66"],
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: { size: "58%" },
        dataLabels: { minAngleToShowLabel: 0, offset: 0 },
      },
    },
    stroke: { width: 2, colors: [isDark ? "#1A252F" : "#FFFFFF"] },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "12px",
        fontWeight: 700,
        colors: ["#FFFFFF"],
      },
      formatter: (_val, opts) => pieSliceLabel(realPct(opts)),
      dropShadow: { enabled: false },
    },
    legend: {
      position: "right",
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: "13px",
      fontWeight: 600,
      markers: { shape: "circle", size: 6, offsetX: -2 },
      formatter: (name, opts) => pieLegendWithValue(name, realPct(opts)),
    },
    tooltip: {
      theme: isDark ? "dark" : "light",
      y: {
        formatter: (_val, opts) => `${realPct(opts).toFixed(1)}%`,
      },
    },
  };

  return (
    <div>
      <div className="rr-chart-period">
        <small>Time Period: {range}</small>
      </div>
      <Chart className="rr-apex" key={`${type}-${isValue}`} type="donut" height={260} width="100%" options={options} series={display} />
      <div className="rr-chart-note">
        <div>Share of Core, Incremental, and Media in sales.</div>
      </div>
    </div>
  );
}

export default PieCharts;
